'use client';
import { Product } from '@interface/product';

export default function AddSchemaOrgData({
  slugTratamientos = '',
  product,
}: {
  slugTratamientos?: string;
  product: Product;
}) {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Product',
    name: product.title,
    image:
      product.beforeAndAfterImages.length > 0
        ? product.beforeAndAfterImages[0].urlBefore
        : `${process.env.NEXT_PUBLIC_PRODUCT_IMG_PATH}${product.flowwwId}/productCard-${product.productCardImagePosition}.png`,
    description: product.extraInformation?.schemaDescription,
    brand: {
      type: 'Brand',
      name: 'Holaglow',
    },
    offers: {
      type: 'Offer',
      url:
        'holaglow.com/' +
        slugTratamientos +
        '/' +
        product.extraInformation?.slug,
      priceCurrency: 'EUR',
      price: product.price,
    },
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
    />
  );
}
